import { useState } from "react";
import ArtistsCalendarList from "./ArtistsCalendarList";
import AppointmentServiceList from "./AppointmentServiceList";

const ServicesCalendarContainer = () => {
  const [selectedView, setSelectedView] = useState<string>("day");

  // return (
  //   <>
  //     {selectedView === "day" && (
  //       <ArtistsCalendarList
  //         selectedView={selectedView}
  //         setSelectedView={setSelectedView}
  //       />
  //     )}
  //     {selectedView !== "day" && (
  //       <AppointmentServiceList
  //         selectedView={selectedView}
  //         setSelectedView={setSelectedView}
  //       />
  //     )}
  //   </>
  // );

  if (selectedView === "day") {
    return (
      <ArtistsCalendarList
        selectedView={selectedView}
        setSelectedView={setSelectedView}
      />
    );
  }
  return (
    <AppointmentServiceList
      selectedView={selectedView}
      setSelectedView={setSelectedView}
    />
  );
};

export default ServicesCalendarContainer;
